import React, { useState } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from "components/sales/datePicker/datePicker";
import Images from "assets/images/imageData";

const FinanceMrfFilter = ({
    applyFilter,
    listFilterData,
    localstorageKey = ''
}) => {
    const filterInputs = {
        mrf_no: "",
        site_number: "",
        mrf_type: '',
        mrf_status: ''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("mrf_filters", JSON.stringify(filterFieldsData));
            }}
        >
            <ConstantInput
                label={"MRF No."}
                value={filterFieldsData && filterFieldsData.mrf_no}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, mrf_no: val });
                }}
            />

            <ConstantInput
                label={"Site Number"}
                value={filterFieldsData && filterFieldsData.site_number}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, site_number: val });
                }}
            />
            <DropDownInput
                label="MRF Type"
                data={[
                    {
                        id: "Installation MRF",
                        name: "Installation MRF",
                    },
                    {
                        id: "Mainatence MRF",
                        name: "Mainatence MRF",
                    },
                    {
                        id: "Additional Tags",
                        name: "Additional Tags",
                    },
                    {
                        id: "Testing/Sample",
                        name: "Testing/Sample",
                    },
                    {
                        id: "Employee",
                        name: "Employee",
                    },
                    {
                        id: "FastTag",
                        name: "FastTag",
                    },
                    {
                        id: "Retailer",
                        name: "Retailer",
                    },
                    {
                        id: "DCC",
                        name: "DCC",
                    },
                    {
                        id: "Other",
                        name: "Other",
                    },
                    {
                        id: "EV",
                        name: "EV",
                    },
                    {
                        id: "POS",
                        name: "POS",
                    },
                    {
                        id: "General",
                        name: "General",
                    },
                    {
                        id: "Emp To Emp",
                        name: "Emp To Emp",
                    },
                    {
                        id: "Emp To Site",
                        name: "Emp To Site",
                    },
                    {
                        id: "Emp To Store",
                        name: "Emp To Store",
                    },
                    {
                        id: "Site To Store",
                        name: "Site To Store",
                    },
                    {
                        id: "Site To Site New Installation",
                        name: "Site To Site New Installation",
                    },
                    {
                        id: "Site To Site Addition Installation",
                        name: "Site To Site Addition Installation",
                    },
                    {
                        id: "Site To Site Mainatence",
                        name: "Site To Site Mainatence",
                    },
                    {
                        id: "Site To Site Testing",
                        name: "Site To Site Testing",
                    },
                    {
                        id: "Site To Site Tag",
                        name: "Site To Site Tag",
                    },
                    {
                        id: "Site To Site POS",
                        name: "Site To Site POS",
                    },
                    {
                        id: "Return Tag",
                        name: "Return Tag",
                    },

                ]}
                getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, mrf_type: val?.id });
                }}
            />
            <DropDownInput
                label="MRF Status"
                data={[
                    {
                        id:  1,
                        name: "Open",
                    },
                    {
                        id:  2,
                        name: "In Progress",
                    },
                    {
                        id:  3,
                        name: "Closed",
                    },
                    {
                        id:  4,
                        name: "Rejected",
                    },
                    {
                        id:  5,
                        name: "Partial Close",
                    },
                    {
                        id:  6,
                        name: "Short Close",
                    },
                    {
                        id:  7,
                        name: "Send to Erp",
                    },

                ]}
                getIdValue={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, mrf_status: val?.id });
                }}
            />
            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br />
                <br />
                <button
                    onClick={() => {
                        localStorage.setItem(localstorageKey, JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem(localstorageKey, JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default FinanceMrfFilter;
